<template>
  <div>
      <v-dialog v-model="editLineItemShowDialog" max-width="500px">
       <v-card>
          <v-card-title>
            <span class="headline">Lot / Gallons</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md10>
                  <v-autocomplete single-line
                    v-model = "editedLineItem.lotNumber"
                    v-on:change = "lotPicked"
                    :items='lotsForVintage'
                    item-text='lotNumber'
                    item-value='lotNumber'
                    label='Lot'
                  >
                  <template slot="item" slot-scope="data">
                    {{data.item.lotNumber}} - {{ data.item.description }}
                  </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editedLineItem.caseCount" label="Cases"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editedLineItem.gallons" label="Gallons"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field v-model="editedLineItem.alc" label="Alcohol"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="closeLineItemEdit">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="saveLineItemEdit">Save</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="editedItemShowDialog" max-width="500px">
      <v-card>
          <v-card-title>
            <span class="headline">BOL Structure Breakout</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md10>
                  <v-text-field v-model="editedItemBreakout.percentage" label="Percentage"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field v-model="editedItemBreakout.vintage" label="Vintage"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-autocomplete single-line
                    v-model = 'editedItemBreakout.varietal'
                    :items='varietals'
                    item-text='name'
                    item-value='id'
                    label='Varietal'
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-autocomplete single-line
                    v-model = 'editedItemBreakout.appellation'
                    :items='appellations'
                    item-text='name'
                    item-value='id'
                    label='Appellation'
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field v-model="editedItemBreakout.vineyard" label="Vineyard"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="closeBreakout">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="saveBreakout">Save</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-toolbar :color='getColor("BOL")' light>
      <v-flex xs3>
        <v-layout row justify-start>
          <v-icon color="primary" @click="goBack">chevron_left</v-icon>
          <div v-if='bol.facilityId > 0'>
            <v-btn xs2 color="primary" v-if="bol.id > 0" @click="createBOL">SAVE</v-btn>
            <v-btn xs2 color="primary" v-else @click="createBOL">CREATE</v-btn>
          </div>
        </v-layout>
      </v-flex>
      <v-flex xs6>
        <v-toolbar-title class="text-xs-center">BILL OF LADING {{bol.id}}</v-toolbar-title>
      </v-flex>
      <v-flex xs3>
        <v-layout row justify-end>
          <v-btn color="primary" @click="printPDF">PRINT PDF</v-btn>
        </v-layout>
      </v-flex>
    </v-toolbar>
    <br>
    <template v-if="loaded">
      <v-layout row>
        <v-flex xs4>
          <BOLTopMain :bol=bol></BOLTopMain>
        </v-flex>
        <v-flex xs8>
          <BOLTopRightLocation :bol=bol v-on:facilityChanged="facilityChanged"></BOLTopRightLocation>
        </v-flex>
      </v-layout>
      <br>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn @click="addLot" color='primary'>ADD LOT</v-btn>
        </v-card-title>
      </v-card>
      <v-data-table
        :headers='headers'
        :items='bol.BOLItems'
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td width="10%"><v-icon
              color="primary"
              small
              class="mr-2"
              @click="editBOLLineItem(props.index)">
                edit
              </v-icon>
              <v-icon
                color="primary"
                small
                class="mr-2"
                @click="deleteBOLLineItem(props.index)">
                  delete
              </v-icon>
            </td>
            <td width="20%">{{ props.item.Lot.lotNumber}}<br> {{ props.item.Lot.description }}</td>
            <td width="5%">{{ props.item.caseCount}}</td>
            <td width="5%">{{ props.item.gallons}}</td>
            <td width="5%">{{ props.item.alc}}</td>
            <td width="60%">
              <v-data-table v-if="bol.direction == 'IN'"
                :headers = 'headers2'
                :items='bol.BOLItems[props.index].BOLItemBreakouts'
                hide-actions>
                <template slot="items" slot-scope="props2">
                  <tr>
                    <td width="10%">{{props2.item.percentage}}</td>
                    <td width="10%">{{props2.item.vintage}}</td>
                    <td width="20%">{{props2.item.varietal}}</td>
                    <td width="20%">{{props2.item.appellation}}</td>
                    <td width="25%">{{props2.item.vineyard}}</td>
                    <td width="15%"><v-icon
                      color="primary"
                      small
                      class="mr-2"
                      @click="editBOLBreakout(props.index, props2.index, props2.item)"
                      >edit</v-icon>
                      <v-icon
                        color="primary"
                        small
                        class="mr-2"
                        @click="deletePercentage(props.index, props2.index)">
                          delete
                      </v-icon>
                    </td>
                  </tr>
                </template>
                <template slot="footer" >
                  <td v-if="bol.BOLItems[props.index].BOLItemBreakouts.length > 0">
                    {{ totalUpPercentages(bol.BOLItems[props.index].BOLItemBreakouts)}}
                  </td>
                  <td v-else>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><v-icon color='primary' @click="addPercentage(props.index)">add</v-icon></td>
                </template>
              </v-data-table>
              <v-treeview v-else
                class="font-weight-thin text-capitalize"
                open-all
                :items="props.item.LotstructureTree"
                >
              </v-treeview>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <br>
    <v-layout row v-if="bol.id >= 0">
      <v-flex xs2></v-flex>
      <v-flex xs8>
        <v-layout justify-center>
          <v-btn @click="deleteBOL" dark color="red accent-4">DELETE BOL</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import BOLTopMain from './BOLTopMain'
import BOLTopRightLocation from './BOLTopRightLocation'
import myMixins from '../mixins/myMixins'

export default {
  components: {
    BOLTopMain,
    BOLTopRightLocation
  },
  data () {
    return {
      newLot: {},
      type: 0,
      newGallons: 0,
      alcohol: 1,
      dialogFooter: false,
      dialog: false,

      editLineItemShowDialog: false,
      editLineItemIndex: 0,

      editedLineItem: {
        gallons: 0,
        lotNumber: '',
        alc: ''
      },
      editedLotIndex: 0,
      editedItemShowDialog: false,
      editedItemBreakoutIndex: 0,
      editedItemBreakout: {

      },
      editedItem: {
        Lot: {}
      },
      editedIndex: -1,
      bol: {
        facilityId: -1,
        BOLItems: [
          { id: 1 },
          { id: 2 }
        ],
        Location: {
          id: -1,
          bondNumber: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zip: '',
          name: ''
        }
      },
      headers2: [
        { text: '%', value: 'percentage', sortable: false },
        { text: 'Vintage', value: 'vintage', sortable: false },
        { text: 'Varietal', value: 'varietal', sortable: false },
        { text: 'Appellation', value: 'appellation', sortable: false },
        { text: 'Vineyard', value: 'vineyard', sortable: false }
      ],
      headers: [
        { text: '', value: 'b', sortable: false },
        { text: 'Lot', value: 'lot', sortable: false },
        { text: 'Cases', value: 'caseCount', sortable: false },
        { text: 'Gallons', value: 'gallons', sortable: false },
        { text: 'Alcohol', value: 'alc', sortable: false },
        { text: 'Composition', value: 'composition', sortable: false }
      ],
      geoCodedAddress: {},
      loaded: false,
      directions: ['IN', 'OUT'],
      taxStatuses: ['BONDTOBOND', 'TAXPAID']
    }
  },
  mixins: [myMixins],
  created () {
    if (this.$route.params.id === '-1') {
      this.bol.date = moment().format()
      this.bol.clientcode = this.clientcode
      this.bol.BOLItems = []
      this.bol.direction = 'OUT'
      this.bol.bonded = 'BONDTOBOND'
      this.bol.Client = this.client
      this.bol.Location = {
        id: -1,
        bondNumber: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        name: ''
      }
      this.loaded=true
    } else {
      this.retrieveBOL()
    }
  },
  computed: {
    lotsAndDescription (item) {
      return item.lotNumber
    },
    marker () {
      let result = { lat: this.geoCodedAddress.latitude, lng: this.geoCodedAddress.longitude }
      if (result.lat) {
        return result
      } else {
        return { lat: 36.6248006, lng: -121.591403 }
      }
    },
    lotsForVintage () {
      return this.$store.state.lotsForVintage
    },
    varietals () {
      return this.$store.state.varietals
    },
    appellations () {
      return this.$store.state.appellations
    },
    facilities () {
      return this.$store.state.facilities
    },
    lots () {
      return this.$store.state.lotsForVintage
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    client () {
      return this.$store.state.client
    }
  },
  methods: {
    facilityChanged () {
      console.log(JSON.stringify(this.bol, null, 2))
    },
    lotPicked (value) {
      let url = process.env.VUE_APP_BACKEND + 'workorders?lot=' + value + '&finalStructOnly=true'
      axios
        .get(url)
        .then(response => {
          console.log(response.data.data.structure.volume.total)
          this.editedLineItem.gallons = response.data.data.structure.volume.total
        })
    },
    printPDF () {
      let url = process.env.VUE_APP_BACKEND + 'billOfLadings/' + this.bol.id + '?pdf=true'
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      )
      // axios
      //   .get({
      //     url: url,
      //     method: 'GET',
      //     responseType: 'blob' }).then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]))
      //     const link = document.createElement('a')
      //     link.href = url
      //     //          link.setAttribute('download', 'file.pdf') // or any other extension
      //     document.body.appendChild(link)
      //     link.click()
      //   }).catch((error) => {
      //     console.log('there was an error')
      //     console.log(error)
      //   })
    },

    deleteBOL () {
      axios
        .delete(process.env.VUE_APP_BACKEND+'BillofLadings/' + this.bol.id)
        .then(response => {
          this.goBack()
        })
    },
    deletePercentage (lineItemIndex, breakOutIndex) {
      this.bol.BOLItems[lineItemIndex].BOLItemBreakouts.splice(breakOutIndex, 1)
    },
    addPercentage (lineItemIndex) {
      console.log('*** got called***')
      if (!this.bol.BOLItems[lineItemIndex].BOLItemBreakouts) {
        Vue.set(this.bol.BOLItems[lineItemIndex], 'BOLItemBreakouts', [{
          vintage: 0,
          percentage: 0,
          varietal: '',
          appellation: '',
          vineyard: ''
        }])
      }
      this.bol.BOLItems[lineItemIndex].BOLItemBreakouts.push({
        bolItemsId: this.bol.BOLItems[lineItemIndex].id,
        vintage: 0,
        percentage: 0,
        varietal: '',
        appellation: '',
        vineyard: ''
      })
      this.$forceUpdate()
    },
    deleteBOLLineItem (index) {
      this.bol.BOLItems.splice(index, 1)
    },
    closeLineItemEdit () {
      this.editLineItemShowDialog = false
    },
    saveLineItemEdit () {
      this.bol.BOLItems[this.editLineItemIndex].gallons = this.editedLineItem.gallons
      this.bol.BOLItems[this.editLineItemIndex].caseCount = this.editedLineItem.caseCount
      this.bol.BOLItems[this.editLineItemIndex].Lot = { lotNumber: this.editedLineItem.lotNumber }
      this.bol.BOLItems[this.editLineItemIndex].lot = this.editedLineItem.lotNumber
      this.bol.BOLItems[this.editLineItemIndex].type = 'WINE'
      if (this.editedLineItem.alc < 16) {
        this.bol.BOLItems[this.editLineItemIndex].alc = '<16%'
      } else {
        this.bol.BOLItems[this.editLineItemIndex].alc = '>=16%'
      }
      this.closeLineItemEdit()
      this.createBOL()
    },
    editBOLLineItem (lotIndex) {
      this.editedLineItem = JSON.parse(JSON.stringify(this.bol.BOLItems[lotIndex]))
      console.log(JSON.stringify(this.editedLineItem, null, 2))
      this.editedLineItem.lotNumber = this.editedLineItem.Lot.lotNumber
      this.editedLineItem.alc = this.editedLineItem.alc
      this.editLineItemIndex = lotIndex
      this.editLineItemShowDialog = true
    },
    addLot () {
      this.bol.BOLItems.push({
        BOLItemBreakouts: [],
        Lot: {
          lotNumber: ''
        },
        clientcode: this.clientcode,
        bolId: this.bol.id,
        gallons: 0
      })
    },
    saveBreakout () {
      let breakOuts = this.bol.BOLItems[this.editedLotIndex].BOLItemBreakouts
      breakOuts[this.editedItemBreakoutIndex].percentage = this.editedItemBreakout.percentage
      breakOuts[this.editedItemBreakoutIndex].vintage = this.editedItemBreakout.vintage
      breakOuts[this.editedItemBreakoutIndex].varietal = this.editedItemBreakout.varietal
      breakOuts[this.editedItemBreakoutIndex].appellation = this.editedItemBreakout.appellation
      breakOuts[this.editedItemBreakoutIndex].vineyard = this.editedItemBreakout.vineyard
      this.editedItemShowDialog = false
    },
    closeBreakout () {
      this.editedItemShowDialog = false
    },
    editBOLBreakout (lotIndex, breakoutIndex, item) {
      this.editedItemBreakoutIndex = breakoutIndex
      this.editedLotIndex = lotIndex
      this.editedItemBreakout = JSON.parse(JSON.stringify(item))
      this.editedItemShowDialog = true
    },
    totalUpPercentages (breakOutItems) {
      let total = 0
      breakOutItems.forEach(function (item) {
        total += item.percentage * 1
      })
      return total
    },
    saveDate (date) {
      this.bol.date = moment(date).add(5, 'hours').format('YYYY-MM-DDThh:mm:ss')
      this.menu = false
    },
    updateLot (value) {
      this.newLot = value
    },
    updateFacility (value) {
      this.bol.facilityId = value.id
      this.bol.Location = value
      this.getLatLong()
    },
    editItem (item) {
      this.editedIndex = this.bol.BOLItems.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      axios
        .delete(process.env.VUE_APP_BACKEND+'BOLItems/' + item.id)
        .then(response => {
          const index = this.bol.BOLItems.indexOf(item)
          this.bol.BOLItems.splice(index, 1)
        })
    },
    save () {
      this.bol.BOLItems[this.editedIndex].gallons = parseFloat(this.editedItem.gallons)
      this.dialog = false
      this.editedItem = -1
    },
    close () {
      this.dialogFooter = false
      this.dialog = false
      this.editedIndex = -1
    },
    updateClient (value) {

    },
    createBOL () {
      console.log(JSON.stringify(this.bol, null, 2))
      axios
        .post(process.env.VUE_APP_BACKEND+'billOfLadings', this.bol)
        .then(response => {
          this.bol = response.data.data
        })
    },
    updateBOL () {

    },
    getLatLong () {
      const address = "'" + this.bol.Location.address1 + ' ' + this.bol.Location.city + ' ' + this.bol.Location.state + "'"
      axios
        .get(process.env.VUE_APP_BACKEND+'geocoder?address=' + address)
        .then(response => {
          this.geoCodedAddress = response.data[0]
          this.geoCodedAddress.lat = this.geoCodedAddress.latitude
          this.geoCodedAddress.lng = this.geoCodedAddress.longitude
        })
    },
    retrieveBOL () {
      if (this.$route.params.id > 0) {
        axios
          .get(process.env.VUE_APP_BACKEND+'billOfLadings/' + this.$route.params.id)
          .then(response => {
            this.bol = response.data.data
            this.loaded=true
            this.getLatLong()
          })
      } else {
        // setup this for when it is a new BOL
      }
    }
  }
}
</script>
<style>
</style>
